var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formBuilder" },
    _vm._l(_vm.formData, function (item) {
      return _c(
        "Accord",
        {
          key: item.title,
          attrs: {
            title: item.title,
            link: _vm.getAnchorLink(item),
            linkName: item.anchor,
          },
        },
        [
          item.description != null
            ? _c("h4", [_vm._v(_vm._s(item.description))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: item.grid },
            [
              _vm._l(item.forms, function (input) {
                return [
                  input.type == "section"
                    ? [
                        _c("Section", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : input.type == "sectionarray"
                    ? [
                        _c("SectionArray", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : input.type == "sectionpicker"
                    ? [
                        _c("SectionPicker", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : input.type == "sectiontable"
                    ? [
                        _c("SectionTable", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : input.type == "materialreviewtable"
                    ? [
                        _c("MaterialReviewTable", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : input.type == "aggregationtable"
                    ? [
                        _c("AggregationTable", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ]
                    : [
                        _c("InputField", {
                          attrs: { input: input, formValue: _vm.formValue },
                        }),
                      ],
                ]
              }),
            ],
            2
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }